import React from 'react';
import { Link } from 'react-router-dom';
import useOutsetaAuth from '../hooks/useOutsetaAuth';
import './ProtectedRoute.css';

// Wraps members-only pages. Outseta decides who is logged in; this component
// only shows the content when Outseta reports an authenticated member.
const ProtectedRoute = ({ children }) => {
  const { status, login } = useOutsetaAuth();

  if (status === 'loading') {
    return (
      <div className="protected-gate">
        <div className="container">
          <p className="protected-gate-status">Checking your membership...</p>
        </div>
      </div>
    );
  }

  if (status !== 'authenticated') {
    return (
      <div className="protected-gate">
        <div className="container">
          <div className="protected-gate-card">
            <h1>Members only</h1>
            <p>
              This part of the website is reserved for EBTA members.
              Please log in with your EBTA membership account to continue.
            </p>
            <button type="button" className="protected-gate-login" onClick={login}>
              Log in
            </button>
            <p className="protected-gate-join">
              Not a member yet? <Link to="/membership">Become a member</Link>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
